<template>
  <div id="publish">
    <el-row v-loading="loading">
      <el-col :offset="2" :span="20">
        <el-form ref="form" :model="form" :rules="formRules" label-position="top">

          <el-form-item label="美食图片" prop="cover">
            <img v-lazyload src="../../static/loading.svg" :data-src="form.cover" data-err="../../static/df.png" class="show-image" v-if="form.cover && form.cover != ''"/>

            <el-input minlength="1" maxlength="150" v-model="form.cover" placeholder="请输入美食图片地址（必填）"></el-input>

            <div class="el-upload__tip">
              推荐上传图片到 <a href="https://img9.top/" target="_blank">无限图床</a>, 请使用正方形图片，尺寸为 480px × 480px, 只能上传jpg/png文件，上传图片前，建议先在 <a href="https://tinypng.com/" target="_blank">tinypng.com</a> 上压缩一下
            </div>
          </el-form-item>

          <el-form-item label="美食标题" prop="title">
            <el-input minlength="1" maxlength="150" v-model="form.title" placeholder="请输入分享的美食标题（必填）"></el-input>
          </el-form-item>

          <el-form-item label="推荐指数" prop="score">
            <el-rate
              show-text
              v-model="form.score"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
            </el-rate>
          </el-form-item>

          <el-form-item label="所在城市" prop="city">
            <el-select v-model="form.city" placeholder="请选择">
              <el-option
                v-for="item in citysOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="详细地址" prop="addr">
            <el-input minlength="1" maxlength="150" v-model="form.addr" placeholder="请输入美食详细地址（必填）"></el-input>
          </el-form-item>

          <el-form-item label="分享描述" prop="content">
            <vue-html5-editor :content="form.content"
                              @change="updateData"
                              :height="350"
                              :z-index="1000"
                              :auto-height="true"
                              :show-module-name="true"
                              placeholder="请输入分享描述（必填）"></vue-html5-editor>

          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitNode" v-if="!queryId">提交DApp</el-button>
            <el-button type="primary" @click="modNode" v-if="queryId">修改DApp</el-button>
            <el-button @click="resetForm('form')" v-if="!queryId">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      queryId: null,
      reload: true,
      citysOptions: ['北京', '上海', '广州', '深圳', '武汉', '南京', '成都', '重庆', '沈阳', '西安', '大连'],
      loading: false,
      form: {
        cover: '',
        title: '',
        score: 0,
        city: '',
        addr: '',
        content: ''
      },
      formRules: {
        cover: [
          {required: true, message: '请上传美食图片', trigger: 'blur'}
        ],
        title: [
          {required: true, message: '请输入分享的美食标题', trigger: 'blur'},
          {min: 1, max: 150, message: '长度在 1 到 150 个字符', trigger: 'blur'}
        ],
        score: [
          {required: true, message: '请输入推荐指数', trigger: 'blur'}
        ],
        city: [
          {required: true, message: '请选择所在城市', trigger: 'blur'}
        ],
        addr: [
          {required: true, message: '请输入美食详细地址', trigger: 'blur'},
          {min: 1, max: 150, message: '长度在 1 到 150 个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入美食分享描述', trigger: 'blur'},
          {min: 1, max: 5000, message: '长度在 1 到 5000 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    updateData: function (d) {
      var vueThis = this;
      vueThis.form.content = d;
    },
    submitNode: function () {
      var vueThis = this
      if (_.isEmpty(vueThis.accounts)) {
        vueThis.showErr('请先登录钱包！');
        return false;
      }
      vueThis.$refs['form'].validate((valid) => {
        if (valid) {
          var f = vueThis.form;
          let params = [f.title, f.cover, f.city, f.addr, f.score, f.content];
          vueThis.loading = true
          vueThis.$store.dispatch('callNew', {funcName: 'addFood', params: params}).then((ret) => {
            vueThis.loading = false
            vueThis.showSuccess('分享美食成功');
            vueThis.$router.push({name: 'mine'})
          }, (error) => {
            vueThis.loading = false
            vueThis.showErr('分享美食失败' + error);
          });
        } else {
          vueThis.showErr('请完善表单必填字段');
        }
      })
    },
    modNode: function () {
      var vueThis = this
      if (_.isEmpty(vueThis.accounts)) {
        vueThis.showErr('请先登录钱包！');
        return false;
      }
      vueThis.$refs['form'].validate((valid) => {
        if (valid) {
          var f = vueThis.form;
          let params = [vueThis.queryId, f.name, f.dtype, f.icon, f.url, f.userName, f.addr, f.txhash, f.desc, f.week, f.reason];
          vueThis.loading = true
          vueThis.$store.dispatch('callNew', {funcName: 'updateDapp', params: params}).then((ret) => {
            vueThis.loading = false
            vueThis.showSuccess('修改美食分享成功');
            vueThis.$router.push({name: 'mine'})
          }, (error) => {
            vueThis.loading = false
            vueThis.showErr('修改美食分享失败' + error);
          });
        } else {
          vueThis.showErr('请完善表单必填字段');
        }
      })
    },
    getDetail: function (id) {
      let vueThis = this;
      if (!id) {
        return;
      }
      vueThis.loading = true;
      vueThis.$store.dispatch('simulateCallNew', {funcName: 'getFoodInfo', params: [id]}).then((ret) => {
        let data = JSON.parse(ret);
        vueThis.form = data;
        vueThis.loading = false;
      }, (error) => {
        vueThis.loading = false;
        vueThis.showErr('获取详情失败' + error);
      });
    },
    resetForm: function (formName) {
      var vueThis = this;
      vueThis.reload = false;
      vueThis.$refs[formName].resetFields();
      _.delay(function () {
        vueThis.reload = true;
      }, 300)
    }
  },
  created () {
    this.queryId = this.$route.query.id;
    this.getDetail(this.queryId)
  },
  computed: mapState([
    'accounts'
  ])
}
</script>

<style>
  #publish {
  }

  #publish  .el-form--label-top .el-form-item__label{
    padding: 0px;
  }

  #publish .show-image {
    max-width: 228px;
    max-height: 228px;
    display: block;
  }

  #publish .text-here {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    line-height: 1.75;
    color: #757575;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #publish .post_meta_top{
    color: #666;
    font-size: 14px;
    font-style: italic;
  }

  #publish .vue-html5-editor img{
    max-width: 90%;
    object-fit: cover;
  }

  #publish .vue-html5-editor>.toolbar>ul>li{
    color: #606266;
  }
</style>



// WEBPACK FOOTER //
// src/components/base-publish.vue